module.exports = __webpack_public_path__ + "img/cute.a017116c.svg";